import * as yup from 'yup'

export const getJourneyValidationSchema = (formatMessage: any) => yup.object({})
